export const LogoMark = ({ size = 40, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 64 64"
    fill="none"
    role="img"
    aria-label="Roma's Café Diner monogram"
    className={className}
  >
    <circle cx="32" cy="32" r="29" stroke="#D4AF37" strokeWidth="2" />
    <circle cx="32" cy="32" r="22.5" stroke="#D4AF37" strokeOpacity="0.35" strokeWidth="1" />
    <path
      d="M26 12c1.8-2 3.6-2 5.4 0M30 8.5c1.2-1.2 2.4-1.2 3.6 0"
      stroke="#C96F3B"
      strokeWidth="1.6"
      strokeLinecap="round"
    />
    <text
      x="32"
      y="42"
      textAnchor="middle"
      fontFamily="'Playfair Display', Georgia, serif"
      fontWeight="600"
      fontSize="27"
      fill="#D4AF37"
    >
      R
    </text>
  </svg>
);

export const Wordmark = ({ compact = false }) => (
  <span className="flex items-center gap-3">
    <LogoMark size={compact ? 34 : 40} />
    <span className="flex flex-col leading-none">
      <span className="font-display text-xl font-semibold tracking-tight text-[#f7f4ef]">
        Roma's
      </span>
      <span className="mt-1 text-[0.6rem] font-semibold uppercase tracking-[0.32em] text-[#d4af37]">
        Café Diner
      </span>
    </span>
  </span>
);
